const exportFieldsOrdered = [
    'id','batchJobId','dateMathCalcRightslineId','loadStatus','loadErrorMsg','createdAt','modifiedAt','deletedAt',
    'sourceType','sourceRightslineId','dateFieldName','dateMathType','dateFieldValue','triggerModuleTemplateId',
    'triggerRightslineId','triggerDateFieldName','calcQuantity','calcPeriod','calcBeforeOrAfter','calcDateMathOffset',
    'recalcOption','conditionOption','calcPriority','recordAction','dateMathCreateType','dealId','catalogId',
    'rightTemplate','description','mediaXrefs','territoryXrefs','languageXrefs','conflictCheck','conflictCheckExclusion',
    'singleRecordTie','exclusivity','earlierLaterComparisonDate'
];

const dateMathTermFieldsOrdered = [
    'id','datemathCalculationId','dateMathCalcRightslineId','dateField','dateMathType','date','triggerField',
    'triggerId','triggerYears','triggerMonths','triggerWeeks','triggerDays','triggerDayType','beforeOrAfter',
    'dateStatus','createdAt','modifiedAt','deletedAt','recalcOption','conditionOption','calcPriority',
    'earlierLaterComparisonDate','triggerModuleTemplateId','dateSelectionType','dateFieldTerm','dateMathSearchType',
    'triggerSearchDealId','triggerSearchCatalogId','termTriggerLabel'
];

const trailingFieldsOrdered = [
    'format','termTriggerLabel','endTermTriggerLabel','mediaIdList','territoryIdList','languageIdList','dateField',
    'date','termDate','triggerId','triggerYears','triggerMonths','triggerWeeks','triggerDays','triggerDayType',
    'beforeOrAfter','triggerEarlierLaterDate','dateStatus','dateMathTypeTerms','endDateFieldTerm','endTermDate',
    'endTermTriggerId','endTermTriggerYears','endTermTriggerMonths','endTermTriggerWeeks','endTermTriggerDays',
    'endTermTriggerDayType','endBeforeOrAfter','endTermTriggerEarlierLaterDate','endDateStatus','dateSelectionType',
    'endDateSelectionType'
];

export function flattenDateMathCalculations(content) {
    const rows = [];
    content?.forEach(item => {
        const terms = Array.isArray(item.dateMathTerms) ? item.dateMathTerms : [item.dateMathTerms];
        terms.forEach((term, idx) => {
            const row = {};
            // Main fields
            exportFieldsOrdered.forEach(key => {
                row[key] = idx === 0 ? item[key] : '';
            });
            // DateMathTerms fields
            dateMathTermFieldsOrdered.forEach(key => {
                row[`dateMathTerms.${key}`] = term ? term[key] : '';
            });
            // Trailing fields
            trailingFieldsOrdered.forEach(key => {
                row[key] = idx === 0 ? item[key] : '';
            });
            rows.push(row);
        });
    });
    return rows;
}